import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import {
  Box,
  Container,
  Paper,
  Typography,
  CardActionArea,
  Link,
  CardMedia,
  CardActions,
  Card,
  Button,
  CardContent,
} from "@mui/material";
import pageNotFoundImg from "../../assets/preview.webp";
import { getDeveloperProject } from "../../features/Developers/developerSlice";

const PageNotFound = () => {
  const { developer, developers } = useSelector((state) => state.developers);
  const { attributes } = developer;

  const { project } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getDeveloperProject(`${project}`));
  }, []);
  return (
    <>
      <Container maxWidth="md">
        <Box
          p={3}
          sx={{
            display: "flex",

            flexDirection: "column",
          }}
        >
          <Paper p={2} m={2}>
            <Box sx={{}}>
              <Box
                component="img"
                sx={{ width: "100%", height: "100%" }}
                src={pageNotFoundImg}
              />
            </Box>
          </Paper>
          <Box p={2} m={2}>
            <Paper>
              <Box
                sx={{
                  justifyContent: "center",
                  display: "flex",
                  flexDirection: "column",
                  textAlign: "center",
                }}
                p={3}
              >
                <Typography mb={2}>Opps sorry you are lost ! </Typography>
                <Button
                  onClick={() => navigate("/dev/dashboard")}
                  p={2}
                  mt={2}
                  variant="outlined"
                >
                  Take me back Home
                </Button>
              </Box>
            </Paper>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default PageNotFound;
